import { render, staticRenderFns } from "./ResearcherDetails.vue?vue&type=template&id=fa94e490&scoped=true&"
import script from "./ResearcherDetails.vue?vue&type=script&lang=js&"
export * from "./ResearcherDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherDetails.vue?vue&type=style&index=0&id=fa94e490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94e490",
  null
  
)

export default component.exports